import React from "react";

export const Page: React.FC = ({ children }) => {
  return (
    <div className="layout-page">
      <div className="container-narrow">
        <div className="content">{children}</div>
      </div>
    </div>
  );
};
